import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { saveState } from './../../../../../redux/actions/entities/io';
import {
  addBackgroundImageToPage,
  changePagesBackgroundImage } from './../../../../../redux/actions/entities/pages';
import {
  changeBookBackgroundColor,
  changeBookBackgroundImage } from './../../../../../redux/actions/ui/bookProperties';

class PageBackgroundImage extends Component {
  shouldComponentUpdate(nextProps) {
    const { thumbnail } = this.props;
    if (nextProps.thumbnail !== thumbnail) {
      return true;
    }
    return false;
  }

  setImage = () => {
    const {
      full, thumbnail, pages, lang, sizes,
    } = this.props;
    this.backgroundSet(thumbnail, full, pages, lang, sizes);
  }

  setBackroundToAllBook(activePage, thumbnail, full, sizes) {
    const { dispatch, coverType } = this.props;

    dispatch(addBackgroundImageToPage(activePage.id, activePage.order, thumbnail, full, sizes, coverType));
    dispatch(changeBookBackgroundColor(null));
    dispatch(changeBookBackgroundImage(thumbnail, full, sizes));
  }

  backgroundSet = (thumbnail, full, pages, lang, sizes) => {
    const { isBabyBook, pages: pagesByID, coverType } = this.props;
    const activePage = Object.values(pages).find(element => element.isActive);
    const bookPages = Object.keys(pagesByID).length;

    if (isBabyBook || bookPages === 1) {
      return this.setBackroundToAllBook(activePage, thumbnail, full, sizes);
    }


    Swal({
      text: lang.color_change_question,
      type: 'question',
      showCancelButton: true,
      confirmButtonText: lang.from_current,
      cancelButtonText: lang.from_first,
    }).then((result) => {
      this.setBackroundToAllBook(activePage, thumbnail, full, sizes);
      if (result.dismiss === Swal.DismissReason.cancel) {
        this.props.dispatch(changePagesBackgroundImage(thumbnail, full, sizes, coverType));
      }
      this.props.dispatch(saveState());
    });
  }

  render() {
    const { src } = this.props;
    return (
      <div
        onClick={() => this.setImage()}
        onKeyDown={() => {}}
        role="presentation"
      >
        <img
          src={src}
          alt=""
        />
      </div>
    );
  }
}

PageBackgroundImage.defaultProps = {
  src: '',
  thumbnail: '',
  full: '',
  pages: {},
  lang: {},
  sizes: {},
  dispatch: () => {},
  isBabyBook: false,
};

PageBackgroundImage.propTypes = {
  src: PropTypes.string,
  thumbnail: PropTypes.string,
  full: PropTypes.string,
  pages: PropTypes.object,
  lang: PropTypes.object,
  sizes: PropTypes.object,
  dispatch: PropTypes.func,
  isBabyBook: PropTypes.bool,
};


export default connect(state => ({
  pages: state.entities.pages.byId,
  isBabyBook: state.bookProperties.isBabyBook,
  coverType: state.bookProperties.cover.type,
}))(PageBackgroundImage);




// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/page-background-image/PageBackgroundImage.jsx